export class Logger {
    static init(isReleaseMode) {
        Logger._isReleaseMode = isReleaseMode;
    }
    static debug(message) {
        if (!Logger._isReleaseMode) {
            console.log(message);
        }
    }
    static info(message) {
        console.info(message);
    }
    static warning(message) {
        console.warn(message);
    }
    static error(message) {
        console.error(message);
    }
}
Logger._isReleaseMode = true;
